(function($) {
    $.Overlay = function () {
        this._component_name = 'overlay';
        this._events = {
            clicked: 'clicked',
            button_clicked: 'button_clicked',
            overlays_loaded: 'overlays_loaded',
            data_loaded: 'data_loaded',
            init_overlay: 'init_overlay',
            ready: 'ready'
        };
        this._overlays = [];
         
        // イベントの設定
        // this._on(this._events.data_loaded, this._emit.bind(this, this._events.ready));
    };

    $.Component.create($.Overlay, {

        _init: function(options) {
            this._parse_options(options);
            $.Component.call(this, $.Overlay);   
        },

        //　必要なデータの読み込みを確認する 
        _check_loaded: function() {
            for(var prop in this._loaded_data) {
                if (this._loaded_data[prop] == false) {
                    return false;
                }
            }

            if (!this._initialized) {
                this._initialized = true; 
                this._emit(this._events.data_loaded); 
            }
            return true;
        },

        _parse_options: function(options) { 
            this._options = options || {};
            this.tracker = this._options.tracker || null;
            this.viewers = this._options.viewers || (this.tracker || {}).viewers || window.viewers || []; 
        
            this.button_id = this._options.btn_nearest_overlay_id || 'btnNearestOverlay';
            this.distance_id = this._options.txt_distance_id || 'txtDistance'; 
            this._default_classname = 'abdo-overlay highlight';
            this._categories_buttons_container = this._options.categories_buttons_container || '.buttons-container';
        
            if (typeof(this._options.categories_buttons_container) === 'string') {
                this._categories_buttons_container = document.querySelector(this._options.categories_buttons_container);
            }
        
            // offset factor
            // オーバーレイが近い位置だとoffset_factor×半径の距離を離す
            if (typeof(this._options.offset_factor) !== 'undefined') {
                this._offset_factor = this._options.offset_factor;
            }
            else {
                this._offset_factor = 0.5;
            }
        
            this._loaded_data = { overlay_buttons: false, overlay_data: false };
            this._initialized = false;
            
            this._min_size = this._options.min_size || 10.0 * window.devicePixelRatio; 

            this._max_size = this._options.max_size || 100.0;

            if (typeof(this._options.callback) === 'function') {
                this._on(this._events.ready, this._options.callback);
            }
            
            this._overlay_size = this._options.overlay_size || 0.01;

            if(typeof(this._options.buttons) !== 'undefined') {
                this._buttons_url = this._options.buttons.url || '';
                if (this._buttons_url) {
                    this._load_buttons();
                }
                this._buttons_element = this._options.buttons.element || '';
                this._buttons_callback = this._options.buttons.callback || null;
        
                if (typeof(this._buttons_element) === 'string') {
                    this._buttons_element = document.getElementById(this._buttons_element);
                } 
            }
 
            this._on(this._events.overlays_loaded, this._init_overlays.bind(this));
            
            if (typeof(this._options.overlays) !== 'undefined') {
                // 配列の場合
                if (typeof(this._options.overlays) === 'object') {
                    this._load_overlays_from_array(this._options.overlays);
                }
                // URLの場合
                else if (typeof(this._options.overlays) === 'string') {
                    ABDOUtil.getJSON(this._options.overlays, this._on_load_json_overlays.bind(this));
                }
            } 
        },

        _load_overlays_from_array: function(array) {
            this._add_overlays_properties(array);
            this._loaded_data.overlay_data = true;
            this._overlays = array;
            this._check_loaded();
            this._emit(this._events.overlays_loaded);
        },
        
        _on_load_json_overlays: function(json_array) {
            this._load_overlays_from_array(json_array);
        },

        _has_fields: function(overlay) {
            for(var prop in overlay) { 
                if (overlay.hasOwnProperty(prop) && 
                    Array.isArray(overlay[prop]) && /(.+)_fields/.exec(prop)) {
                        return true;
                }
            }

            return false;
        },

        _add_overlays_properties: function(overlays) { 
            for (var i = 0; i < overlays.length; i++) {
                var overlay = overlays[i];
                this._add_overlay_properties(overlay);
                overlay.id = 'overlay' + i; 
                
                // todo move to tip.js
                if (this._has_fields(overlay)) {
                    overlay.tip = 'tip' + i;
                }
            } 
        },

        _add_overlay_properties: function(overlay) {
            if (!("width" in overlay)) {
                overlay.width = this._overlay_size;
            }
            if (!("height" in overlay)) {
                overlay.height = this._overlay_size;
            }
            
            if (!("className" in overlay)) {
                overlay.className = this._default_classname;
            }

            if (overlay.evacuation_place) {
                overlay.className += ' evacuation-place';
            } 

            overlay.rotationMode = OpenSeadragon.OverlayRotationMode.NO_ROTATION;
        },

        _load_buttons: function() { 
            var xhr = new XMLHttpRequest();
            xhr.open('GET', this._buttons_url, true);
            xhr.addEventListener('load', this._on_load_buttons.bind(this, xhr)); 
            xhr.send(); 
        },

        _create_buttons_from_overlays: function() {
            var index, overlays_n = this._overlays.length;
            for (index = 0; index < overlays_n; index++) { 
                this._create_button_from_overlay(this._overlays[index]);
            }

            this._loaded_data.overlay_buttons = true;
            this._check_loaded();
        },

        _create_button_from_overlay: function(overlay_data) {
            var buttons = [];
 
            if (!("categories" in overlay_data)) {
                return buttons;
            }

            for (var cat_index = 0; cat_index < overlay_data.categories.length; cat_index++) {
                var category = overlay_data.categories[cat_index];
                var modal = this._get_category_modal(category);
                var container = modal.querySelector('.overlay_buttons');
                var button = this._create_overlay_button(overlay_data);
                
                container.appendChild(button);
                this._assign_button_event(button);

                buttons.push(button);
            }

            return buttons;
        },

        _create_overlay_button: function(overlay_data, index) {
            var button = document.createElement('button');
            button.classList.add("btn-overlay");
            button.classList.add("btn_style_1");
            button.classList.add("transition");
            button.classList.add("carousel-button");
            button.dataset.showtip = true;
            button.dataset.dismiss = 'modal';
            button.dataset.overlay = overlay_data.element.id;
            button.dataset.langkey = overlay_data.name;
            button.innerHTML = overlay_data.name;
            
            return button;
        },

        _get_category_modal: function(category) {
            var selector = '.buttons-modal[data-category="' + category + '"]';
            var modal_element = document.querySelector(selector);
            if (!modal_element) { 
                modal_element = document.querySelector('.buttons-modal').cloneNode(true);
                modal_element.dataset.category = category;
                document.body.appendChild(modal_element);  

                if (this._categories_buttons_container) {
                    var button = document.createElement('button');
                    button.classList.add('btn_style_1', 'transition', 'carousel-button', 'btn-overlay-category');
                    button.dataset.category = category;
                    button.dataset.langkey = category;
                    button.innerHTML = category;
                    
                    button.addEventListener(ABDOUtil.getClickHandler(button), function(evt){
                        jQuery(modal_element).modal();
                    }, false);
    
                    this._categories_buttons_container.prepend(button);
                }
            }

            return modal_element;
        },

        _assign_buttons_events: function(parent_element) { 
            var nodelist = parent_element.getElementsByClassName('btn-overlay');
            for (var index = 0; index < nodelist.length; index++) {
                var button = nodelist[index];
                
                this._assign_button_event(button);
            }
        },
        
        _assign_button_event: function(button) { 
            button.addEventListener(ABDOUtil.getClickHandler(button), this._btn_clicked.bind(this));
        },

        _on_load_buttons: function(request) { 
             // ローカルだとrequest.status == 0
             if (request.status == 0 || (request.status >= 200 && request.status < 400)) {
                if (typeof(this._buttons_element) === 'object') {
                    this._buttons_element.innerHTML = request.responseText;

                    this._assign_buttons_events(this._buttons_element);

                    this._loaded_data.overlay_buttons = true;
                    this._check_loaded();

                    if (typeof(this._buttons_callback) === 'function') {
                        this._buttons_callback(this._buttons_element, request.responseText);
                    }
                }
            }
        },

        // _add_overlays_click_handlers: function() {
        //     var overlay_elements = document.getElementsByClassName('abdo-overlay');
        //     var self = this;
        //     for (var i = 0; i < overlay_elements.length; i++) {
        //         var element = overlay_elements[i];
        //         element.addEventListener(ABDOUtil.getClickHandler(element), function(evt) { 
        //             self.overlayClicked.call(self, evt, this);
        //         });
        //     }
        //     this._initialized = true;
        // }, 

        overlayClicked: function(overlay_element, evt) {
            var viewer = ABDOUtil.getViewer(); 
            var overlay_osd = viewer.getOverlayById(overlay_element.id); 
            
            if (this.tracker) {
                this.tracker.enableScroll(false);
            }

            this._emit(this._events.clicked, evt, overlay_element, overlay_osd); 
        },  

        _removeClass: function(element, css_class) {
            if (ABDOUtil.isIE) {
                element.setAttribute('class', element.getAttribute('class').replace(css_class, ' '));
            }
            else {
                element.classList.remove(css_class);
            }
        }, 

        _preventCanvasClickPropagation: function(element) {
            if (typeof(element.tracker) === 'undefined')  {
                var mouse_tracker = new OpenSeadragon.MouseTracker({
                    element: element
                });
                element.tracker = mouse_tracker;
            }
           
        }, 

        _get_nearest_overlay: function(viewer, overlay){
            var nearest_index = -1;
            var nearest_distance = Number.MAX_VALUE;
            viewer.currentOverlays.forEach(function(added_overlay, added_index) {
                var centers_distance = Math.pow(added_overlay.location.x - overlay.x, 2) + Math.pow(added_overlay.location.y - overlay.y, 2);
                // 大きさは同値である前提で距離を測っている
                // 形が違うと変更することになる
                var distance = centers_distance;
                
                if (distance < nearest_distance) {
                    nearest_distance = distance;
                    nearest_index = added_index;
                }
            });

            return {
                index: nearest_index, 
                distance: Math.sqrt(nearest_distance)
            };
        },

        /**
         * Generate a displacement by options.offset_factor if overlays overlap
         * @param {*} viewer 
         * @param {*} overlay 
         */
        _handle_offset_factor: function(viewer, overlay) { 
            if (this._offset_factor > 0.0)  { 
                var nearest_data = this._get_nearest_overlay(viewer, overlay);
                var overlay_radius = this._overlay_size / 2.0; 
                if (nearest_data.distances < overlay_radius) {
                    var nearest_overlay = viewer.currentOverlays[nearest_data.index];
                    var offsets = [- this._offset_factor*overlay_radius, this._offset_factor*overlay_radius];
                    if (overlay.x < nearest_overlay.location.x) {
                        offsets[0] *= -1;
                        offsets[1] *= -1;
                    }
                    
                    nearest_overlay.location.x += offsets[0];
                    overlay.x += offsets[1];

                    viewer.updateOverlay(nearest_overlay);
                }
            }
        },

        _get_transform: function(position, size) {
            var x = position.x - (size.x/2.0);
            var y = position.y - (size.y/2.0);
            var translation = 'translateX(' + x + 'px) translateY(' + y + 'px)';
            return translation;
        },

        _on_draw: function(position, size, element) { 
            ABDOUtil._resize_overlay(size, this._max_size);

            // set size to 1 and use CSS scale() later
            // if (!element.style.width) {
            //     element.style.width = '1px';
            // }
            // if (!element.style.height) {
            //     element.style.height = '1px';
            // }
            element.style.width = size.x + 'px';
            element.style.height = size.y + 'px';


            // top and left set to 0 to use CSS translate later
            if (!element.style.left) {
                element.style.left = '0px';
            }

            if (!element.style.top) {
                element.style.top = '0px';
            }   
            // var scale = 'scaleX(' + size.x + ') scaleY(' + size.y + ')';
            element.style.transform = this._get_transform(position, size);

            // element.style.left = position.x + 'px';
            // element.style.top = position.y + 'px';

            var min_size = Math.min.apply(this, [size.x, size.y]); 
            if (min_size < this._min_size) {
                element.classList.add('d-none');
            }
            else {
                element.classList.remove('d-none');
            }

            
        },
        
        _append_overlay: function(viewer, overlay) {
            // disabled now that overlays can have a maximum size in pixels
            // this._handle_offset_factor(viewer, overlay); 
            this._add_overlay_properties(overlay);

            if (typeof(overlay.element) === "undefined") {
                overlay.element = document.createElement('div');
                overlay.element.id = overlay.id;
                overlay.element.className = overlay.className;
                document.body.appendChild(overlay.element);
            }

            overlay.onDraw = this._on_draw.bind(this);

            viewer.addOverlay(overlay);
        },

        _init_overlays: function() { 
            for (var index = 0; index < this._overlays.length; index++) {
                this._add_overlay(this._overlays[index]); 
            }

            this._emit(this._events.ready);
        },

        _add_overlay: function(overlay) { 
            if (!("added" in overlay)) {
                overlay.added = false;
            }
            var viewer = ABDOUtil.getViewer();
            if (viewer && !overlay.added) {
                this._append_overlay(viewer, overlay);
                this._init_overlay_viewer(viewer, overlay);
                this._create_button_from_overlay(overlay);
                
                overlay.element.addEventListener(
                    ABDOUtil.getClickHandler(overlay.element), this.overlayClicked.bind(this, overlay.element));

                overlay.added = true;
            }
            
        },
       
        _init_overlay_viewer: function(viewer, overlay_prop) {
            var overlay = viewer.getOverlayById(overlay_prop.id || overlay_prop.element.id);
            var overlayElement = overlay.element;
            this._preventCanvasClickPropagation(overlayElement);

            this._emit(this._events.init_overlay, overlay, overlay_prop);
        },

        // _finish_init: function () {  
        //     this._add_overlays_click_handlers();
        //     this._emit(this._events.ready); 
        // },

        _btn_clicked: function(evt) {  
            var btn = evt.currentTarget;
            var viewer = ABDOUtil.getViewer(); 
            if (typeof(btn.dataset.overlay) !== 'undefined') { 
                var overlay = viewer.getOverlayById(btn.dataset.overlay);
                if (overlay != null) {
                    var rect = $.Overlay.getOverlayRect(overlay, 3);
                    viewer.viewport.fitBounds(rect, true);

                    if (this.parent.tracker) {
                        this.parent.tracker.enableScroll(false);
                    }

                    this._emit(this._events.button_clicked, evt, btn, overlay);
                }
            }  
        }
    }, $.OSD);
 
    $.Overlay.getOverlayRect = function(overlay, factor) {
        factor = factor || 5;
        var size = overlay.bounds.width;
        if (size < overlay.bounds.height) {
            size = overlay.bounds.height;
        }
        
        var x = overlay.bounds.x;
        var y = overlay.bounds.y;
        var offset = size*factor;

        return new OpenSeadragon.Rect(x - offset, y - offset, offset*2, offset*2);
    };
 
    //inherit from component
}(ABDOMap));

// // to avoid uglify deletion
// (function() { new ABDOMap.Overlay(); })();